export default __webpack_public_path__ + "static/media/rabbit_type_8_1.5be57ef7.svg";